import { Globe2 } from "lucide-react";

interface ProfileLanguagesProps {
  languages: string[];
}

export const ProfileLanguages = ({ languages }: ProfileLanguagesProps) => {
  if (!languages?.length) return null;

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <Globe2 className="w-5 h-5 text-gray-600" />
        <h3 className="font-semibold">Languages</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {languages.map((language: string, idx: number) => (
          <span 
            key={idx}
            className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm"
          >
            {language}
          </span>
        ))}
      </div>
    </div>
  );
};